import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import adminTheme from './theme/adminTheme';

// Components
import Login from './components/auth/Login';
import ProtectedRoute from './components/auth/ProtectedRoute';
import UsersManagement from './components/users/UsersManagement';
import DocumentVerification from './components/documents/DocumentVerification';
import ProfileManagement from './components/profiles/ProfileManagement';
import MembershipManagement from './components/memberships/MembershipManagement';
import Settings from './components/settings/Settings';
import ActivityLogs from './components/logs/ActivityLogs.jsx';
import Dashboard from './components/dashboard/Dashboard';
import Layout from './components/layout/Layout';
import VerificationList from './components/verification/VerificationList.jsx';
import PlansManagement from './components/plans/PlansManagement';
import PlansDashboard from './components/plans/PlansDashboard';
import SubscriptionManagement from './components/subscriptions/SubscriptionManagement';
import { ADMIN_ROLES } from './constants/adminRoles';
import AdminRolesManagement from './components/adminRoles/AdminRolesManagement';
import AboutMeVerification from './components/aboutMe/AboutMeVerification';
import PhotoVerification from './components/photos/PhotoVerification';
import PaymentAttempts from './components/payments/PaymentAttempts';

function App() {
  return (
    <ThemeProvider theme={adminTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout>
                  <Navigate to="/dashboard" replace />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Layout>
                  <UsersManagement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/documents"
            element={
              <ProtectedRoute>
                <Layout>
                  <DocumentVerification />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/profiles"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProfileManagement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/memberships"
            element={
              <ProtectedRoute>
                <Layout>
                  <MembershipManagement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute allowedRoles={[ADMIN_ROLES.SUPERADMIN]}>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/logs"
            element={
              <ProtectedRoute>
                <Layout>
                  <ActivityLogs />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/verifications"
            element={
              <ProtectedRoute>
                <Layout>
                  <VerificationList />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plans"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlansManagement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/plans/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <PlansDashboard />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscriptions"
            element={
              <ProtectedRoute>
                <Layout>
                  <SubscriptionManagement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/payment-attempts"
            element={
              <ProtectedRoute>
                <Layout>
                  <PaymentAttempts />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-roles"
            element={
              <ProtectedRoute allowedRoles={[ADMIN_ROLES.SUPERADMIN]}>
                <Layout>
                  <AdminRolesManagement />
                </Layout>
              </ProtectedRoute>
            }
          />
          <Route path='/about-me-verification' element={<ProtectedRoute><Layout><AboutMeVerification /></Layout></ProtectedRoute>} />
          <Route path='/photo-verification' element={<ProtectedRoute><Layout><PhotoVerification /></Layout></ProtectedRoute>} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
